module.exports = __webpack_public_path__ + "vue-dist/img/logo.b0a8c60d.png";